import React from 'react';
import Button from '@/app/components/button';
import LazyAssets from '@/app/utils/assets_widget';
import { t } from 'i18next';
import { s } from '@/app/utils/s';
import styles from '../styles.module.scss';

interface LogoutButtonProps {
  onClick: () => void;
  isDesktop?: boolean;
  className?: string;
}

/**
 * Button component for triggering logout action
 */
const LogoutButton: React.FC<LogoutButtonProps> = ({
  onClick,
  isDesktop = false,
  className,
}) => {
  if (isDesktop) {
    return (
      <Button 
        text={t(s.logOut)} 
        icon={<LazyAssets.LogOut />} 
        isTransparent 
        onClick={onClick} 
        isRedText 
        alignLeft
        className={className}
      />
    );
  }

  return (
    <div className={`${styles.buttons} ${className || ''}`}>
      <Button 
        text={t(s.logOut)} 
        icon={<LazyAssets.LogOut />} 
        isViolet 
        onClick={onClick}
      />
    </div>
  );
};

export default LogoutButton;